// src/locales/en/errors.js
export const errors = {
    somethingWentWrong: "යමක් වැරදී ගියේය. කරුණාකර නැවත උත්සාහ කරන්න.",
    networkError: "ජාල දෝෂයක්. කරුණාකර ඔබේ සම්බන්ධතාවය පරීක්ෂා කරන්න.",
    permissionDenied: "අවසර ප්‍රතික්ෂේප විය. ඔබට මෙම සම්පතට ප්‍රවේශයක් නැත.",
    pageNotFound: "පිටුව හමු නොවිණි",
    notFound: "හමු නොවිණි",
    sessionExpired: "ඔබේ සැසිය අවසන් වී ඇත. කරුණාකර නැවත පිවිසෙන්න.",
    invalidData: "වලංගු නොවන දත්ත සපයන ලදී",
    serverError: "සේවාදායක දෝෂයක්. කරුණාකර පසුව නැවත උත්සාහ කරන්න.",
    loadingError: "පූරණ දෝෂය",
}